// @ts-nocheck
/* Verbatim port of v1 components/partials/dashboard/company/LicenceAllocationPanel.js */
import React from 'react';
import { FiInfo, FiMinus, FiPlus } from 'react-icons/fi';

function normalizeLicenceInput(raw) {
  if (raw === '' || raw == null) return '';
  const digits = String(raw).replace(/\D/g, '');
  if (digits === '') return '';
  return String(parseInt(digits, 10));
}

function LicenceStepper({
  value,
  onChange,
  onDecrement,
  onIncrement,
  disabledMinus,
  disabledPlus,
  readOnly,
}) {
  const handleInputChange = (raw) => {
    const normalized = normalizeLicenceInput(raw);
    onChange(normalized === '' ? '' : normalized);
  };

  return (
    <div className="licence-stepper">
      <button
        type="button"
        className="licence-stepper__btn"
        onClick={onDecrement}
        disabled={readOnly || disabledMinus}
        aria-label="Decrease"
      >
        <FiMinus size={14} />
      </button>
      <input
        type="text"
        inputMode="numeric"
        pattern="[0-9]*"
        className="licence-stepper__input"
        value={value}
        onChange={(e) => handleInputChange(e.target.value)}
        onBlur={(e) => {
          if (e.target.value === '') {
            onChange('0');
          }
        }}
        readOnly={readOnly}
        aria-label="Licence count"
      />
      <button
        type="button"
        className="licence-stepper__btn"
        onClick={onIncrement}
        disabled={readOnly || disabledPlus}
        aria-label="Increase"
      >
        <FiPlus size={14} />
      </button>
    </div>
  );
}

function LicenceColumn({
  icon: Icon,
  iconModifier,
  title,
  description,
  value,
  onChange,
  onDecrement,
  onIncrement,
  disabledMinus,
  disabledPlus,
  error,
  readOnly,
}) {
  return (
    <div className="licence-allocation-col">
      <span className={`licence-allocation-col__icon licence-allocation-col__icon--${iconModifier}`}>
        <Icon size={22} />
      </span>
      <div className="licence-allocation-col__title">{title}</div>
      <div className="licence-allocation-col__desc">{description}</div>
      <LicenceStepper
        value={value}
        onChange={onChange}
        onDecrement={onDecrement}
        onIncrement={onIncrement}
        disabledMinus={disabledMinus}
        disabledPlus={disabledPlus}
        readOnly={readOnly}
      />
      {error ? <small className="text-danger licence-allocation-col__error">{error}</small> : null}
    </div>
  );
}

export default function LicenceAllocationPanel({
  columns = [],
  noteMessage,
  showNote = true,
  footerNote,
  availableSummary,
  subtitle = 'Assign licenses for this company',
}) {
  return (
    <section className="licence-allocation-panel">
      <div className="licence-allocation-panel__header">
        <div>
          <h5 className="licence-allocation-panel__title">Licence allocation</h5>
          <p className="licence-allocation-panel__subtitle">{subtitle}</p>
        </div>
        {showNote && noteMessage ? (
          <div className="licence-allocation-panel__note">
            <FiInfo className="licence-allocation-panel__note-icon" aria-hidden />
            <span>
              <strong>Note: </strong>
              {noteMessage}
            </span>
          </div>
        ) : null}
      </div>

      {availableSummary ? (
        <div className="licence-allocation-panel__available">{availableSummary}</div>
      ) : null}

      <div className="licence-allocation-panel__grid">
        {columns.map((col) => {
          if (col.hidden) return null;
          const { key, ...rest } = col;
          return <LicenceColumn key={key} {...rest} />;
        })}
      </div>

      {footerNote ? (
        <div className="licence-allocation-panel__footer-note">
          <FiInfo className="licence-allocation-panel__note-icon" aria-hidden />
          <span>
            <strong>Note: </strong>
            {footerNote}
          </span>
        </div>
      ) : null}
    </section>
  );
}
